import Vue from 'vue';
import Router from 'vue-router';
import HelloWorld from '@/components/HelloWorld';
import Login from '@/components/Login/Login';
import PrivacyPolicy from '@/components/Login/PrivacyPolicy';
import Terms from '@/components/Login/Terms';
import Chat from '@/components/List/Chat';
import ChatList from '@/components/List/ChatList';
import SiteList from '@/components/List/SiteList';
import ArchivedChat from '@/components/List/ArchivedChat';
import UserList from '@/components/Users/UserList';
import UserDetail from '@/components/Users/UserDetail';
import UserCreate from '@/components/Users/UserCreate';
import UserEdit from '@/components/Users/UserEdit';
import CustomerList from '@/components/Customer/CustomerList';
import CustomerDetails from '@/components/Customer/CustomerDetails';
import ChatDetail from '@/components/Login/ChatDetail';
import MailList from '@/components/Users/MailList';
import AddUpdateSectionScheduleTime from '@/components/SectionScheduler/AddUpdateSectionScheduleTime';
import ListSectionSchedulerTime from '@/components/SectionScheduler/ListSectionSchedulerTime';
Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'Login',
            component: Login
        },
        {
            path: '/privacy/policy',
            name: 'PrivacyPolicy',
            component: PrivacyPolicy
        },
        {
            path: '/terms',
            name: 'Terms',
            component: Terms
        },
        {
            path: '/chat/detail/:id',
            name: 'ChatDetail',
            component: ChatDetail
        },
        {
            path: '/chat',
            name: 'Chat',
            component: Chat
        },
        {
            path: '/chat/list',
            name: 'ChatList',
            component: ChatList
        },
        {
            path: '/user/list',
            name: 'UserList',
            component: UserList
        },
        {
            path: '/user/edit/:id',
            name: 'UserEdit',
            component: UserCreate
        },
        {
            path: '/user/add',
            name: 'UserCreate',
            component: UserCreate
        },
        {
            path: '/user/detail/:id',
            name: 'UserDetail',
            component: UserDetail
        },
        {
            path: '/customer/list',
            name: 'CustomerList',
            component: CustomerList
        },
        {
            path: '/site/list',
            name: 'SiteList',
            component: SiteList
        },
        {
            path: '/archived/chat',
            name: 'ArchivedChat',
            component: ArchivedChat
        },
        {
            path: '/customer/detail/:id',
            name: 'CustomerDetails',
            component: CustomerDetails
        },
        {
            path: '/mail/list',
            name: 'MailList',
            component: MailList
        },
        {
            path: '/sectionscheduletime/add',
            name: 'AddSectionScheduleTime',
            component: AddUpdateSectionScheduleTime
        },
        {
            path: '/sectionscheduletime/update/:id',
            name: 'UpdateSectionScheduleTime',
            component: AddUpdateSectionScheduleTime,
        },
        {
            path: '/sectionscheduletime/list',
            name: 'ListSectionSchedulerTime',
            component: ListSectionSchedulerTime
        },
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js